
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
// import Canvas2Image from '@/utils/a.js'
import { onMounted, ref } from '@vue/runtime-core'
import { useRoute } from 'vue-router'

import { useCommonUserRankInfoEffect } from '@/effects/sdwsEffect.js'
import Utils from '@/utils/utils'
export default {
  name: 'poster',
  props: {
    resInfo: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    const { qrcodeUrl } = useQrcodeEffect()

    const { user } = useCommonUserRankInfoEffect()

    return {
      qrcodeUrl,
      Utils,
      user
    }
  }
}

// qrcode
const useQrcodeEffect = () => {
  const qrcodeUrl = ref('')
  const generateQR = async text => {
    try {
      qrcodeUrl.value = await QRCode.toDataURL(text)
      const poster = document.getElementById('poster')
      setTimeout(() => {
        html2canvas(poster, {
          // allowTaint: true
          useCORS: true
        }).then(function(canvas) {
          var img = new Image()
          img.crossOrigin = 'anonymous'
          img.src = canvas.toDataURL('image/png')
          img.style.width = '100%'
          img.style.height = '100%'
          document.querySelector('.img-wrap').appendChild(img)
        })
      }, 0)
    } catch (err) {
      console.error(err)
    }
  }

  const route = useRoute()

  onMounted(() => {
    generateQR(`
    https://qlwhdh.iqilu.com/h5/#/custom/sdws/?questionActiveKey=${route.query.questionActiveKey}&orgid=${route.query.orgid}
    `)
  })

  return {
    qrcodeUrl
  }
}

